export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result || '');
      const base64 = result.includes(',') ? result.split(',')[1] : result;
      resolve({
        fileName: file.name,
        mimeType: file.type,
        contentBase64: base64
      });
    };
    reader.onerror = () => reject(new Error('Neuspješno učitavanje datoteke.'));
    reader.readAsDataURL(file);
  });
}
